<template>
    <div id="chuangManagement">
        <!-- <div :class="{'animated rollIn': !isAnimateChangeLanguageOn, 
                        'animated rollOut': isAnimateChangeLanguageOn}" > -->
            <div :class="{}" >
            <h5 id="chuang-management-title">{{ managementLanguages[selectedLanguage] }}</h5>
            <div class="row overwrite-row ">
                <div class=" chuang-management-list-container col s12 m12 l3 xl3" v-for="item in managements" :key="item.id">
                    <div class="chuang-management-list-image">
                        <img :src="item.imagePath" alt="">
                    </div>
                    <div class="chuang-management-list-title">
                        <h5>{{ item.title[selectedLanguage] }}</h5>
                    </div>
                    <div class="chuang-management-list-description">
                        <p>{{ item.description[selectedLanguage] }}</p> 
                    </div>
                </div>
            </div>
        </div>

        <div id="competitiveLink"></div>
    </div>
    
</template>

<script>
    export default {
        data() {
            return {
                isAnimateChangeLanguageOn: false,
                isAnimateListOn: false,
                managementLanguages: ['經營理念', '经营理念', 'MANAGEMENT PHILOSOPHY'],
                managements: 
                [
                    {
                        imagePath: require('../assets/images/management-01.png'),
                        title: 
                        [
                            '企業願景',
                            '企业愿景',
                            'Corporate Vision'
                        ],
                        description: 
                        [
                            '不斷創新，開發具獨特性的遊戲軟體，以業界優良品牌為目標，追求卓越進步，跳出以往的框架桎梏，突破創新並帶給客戶端不同的用戶體驗。',
                            '不断创新，开发具独特性的游戏软件，以业界优良品牌为目标，追求卓越进步，跳出以往的框架桎梏，突破创新并带给客户端不同的用户体验。',
                            'Continuous innovation in technology and develop unique gaming software. With a goal to build a reputation in this industry, we strive hard for excellence and constant improvement, jump out of the circle and give our customers an experience they never had before.'
                        ]

                    },
                    {
                        imagePath: require('../assets/images/management-02.png'),
                        title:
                        [
                            '優質的團隊合作',
                            '优质的团队合作',
                            'Excellent Team Work'
                        ] ,
                        description:
                        [   
                            '公司研發部門同仁擁有專業技術及有品質服務，在透過團隊合作及相互學習同時，亦獲得更大成就及革新的成長動力。',
                            '公司研发部门同仁拥有专业技术及有质量服务，在透过团队合作及相互学习同时，亦获得更大成就及革新的成长动力。',
                            'Our professional research and  development department provides specialized skills and quality service. Working and learning with each other enables us to achieve greater goals.'
                        ] 
                    },
                    {
                        imagePath: require('../assets/images/management-03.png'),
                        title: 
                        [
                            '追求卓越',
                            '追求卓越',
                            'Pursue the Highest Quality'
                        ] ,
                        description: 
                        [
                            '善於吸收過往經驗，不斷探索、優化、創新，經過慎密的思維討論，傳統遊戲領域全面佈局的同時，突破創新技術，獲得改善與增加市場競爭力。樂於接受意見與改進，為公司全體同仁職涯發展帶來新契機與滿足，達到企業組織的整體目標。',
                            '善于吸收过往经验，不断探索、优化、创新，经过慎密的思维讨论，传统游戏领域全面布局的同时，突破创新技术，获得改善与增加市场竞争力。乐于接受意见与改进，为公司全体同仁职涯发展带来新契机与满足，达到企业组织的整体目标。', 
                            'We learn from our experiences, break through technological innovation to improve products and build up market competence. We take delight in hearing different opinions and improve ourselves in order to meet achieve the goals of the company.'
                        ]
                    },                    
                    {
                        imagePath: require('../assets/images/management-04.png'),
                        title:
                        [
                            '致力目標',
                            '致力目标',
                            'Essential Aim'
                        ] ,
                        description: 
                        [
                            '不斷創造最佳價值是創樂的致力目標。縝密規劃、積極卓越的創新技術服務行動，因應瞬息萬變的科技產業特性。',
                            '不断创造最佳价值是创乐的致力目标。缜密规划、积极卓越的创新技术服务行动，因应瞬息万变的科技产业特性。',
                            'Continuously create the best value  is our aim. Deliberate planning and outstanding technical service to adapt to the constantly changing industry.'
                        ]
                    },
                ],
                selectedLanguage: 0
            }
        },
        methods: {
            startChangeLangAnimation(){
                let _this = this;
                this.isAnimateChangeLanguageOn = true;
                setTimeout(function() {
                    _this.isAnimateChangeLanguageOn = false;
                }, 1);
            },
        },
        mounted: function() {
            let _this = this;
            this.$root.$on('languageChange', function(e){      
                _this.selectedLanguage = parseInt(e);
            })
            this.$root.$off('animageChangeLanguage', function(e){
                 _this.startChangeLangAnimation();
            })
            window.addEventListener('resize', function(e){
                let h = document.getElementById('chuangManagement').offsetHeight;
                _this.$root.$emit('updateMngSize', h)
            });
             window.addEventListener('load', function(e){
                let h = document.getElementById('chuangManagement').offsetHeight;
                _this.$root.$emit('updateMngSize', h)
            });
        },
        created(){
            //console.log(this.folderName);
        }
    }
</script>

<style lang="less" scoped>
@import url('../assets/css/base.less');

    #competitiveLink {
        height: 90px;
        position: absolute;
        bottom:0;
        @media @1920 {
            height: 5.7rem;
        }
        @media @1600 {
            height: 5.7rem;
        }
        @media @1400 {
            height: 5.7rem;
        }
        @media @1200 {
            height: 5.8rem;
        }
        @media @990 {
            height: 5.5rem;
        }
        @media @768 {
            height: 4.3rem;
        }
        @media @479 {
            height: 4.3rem;
        }
        @media @360 {
            height: 4.3rem;
        }
        @media @320 {
            height: 4.3rem;
        }
    }
    #chuangManagement {
        background: url('../assets/images/management-bg-pc.png') no-repeat center;
        background-size: cover;
        min-width: @min-width;
        position: relative;
        #chuang-management-title {
            margin: 0 auto;;
            color: #e5e5e5;
            text-align: center;
            padding-top: 4rem;
            padding-bottom: 5rem;
            font-size: @cons-main-text-size-1920;
            width: 100%;
            @media @1920 {
                font-size: @cons-main-text-size-1920;
            }
            @media @1600 {
                font-size: @cons-main-text-size-1920;
            }
            @media @1400 {
                font-size: @cons-main-text-size-1920;
            }
            @media @1200 {
                font-size: @cons-main-text-size-1920;
            }
            @media @990 {
                font-size: @cons-main-text-size-1920;
                padding-bottom: 3rem;
            }
            @media @768 {
                font-size: @cons-main-text-size-1920;
                padding-bottom: 3rem;
            }
            @media @479 {
                font-size: @cons-main-text-size-1920;
                width: 20rem;
                padding-bottom: 3rem;
            }
        }
        .chuang-management-list-image {
            width: @cons-mng-img-width-size-1920;
            margin: 0 auto;
            @media @1920 {
                width: @cons-mng-img-width-size-1920;
            }
            @media @1600 {
                width: @cons-mng-img-width-size-1600;
            }
            @media @1400 {
                width: @cons-mng-img-width-size-1400;
            }
            @media @1200 {
                width: @cons-mng-img-width-size-1200;
            }
            @media @990 {
                width: @cons-mng-img-width-size-1920;
            }
            @media @768 {
                width: @cons-mng-img-width-size-1920;
            }
            @media @479 {
                width: @cons-mng-img-width-size-479;
            }
            img {
                width: 100%;
                height: 100%;
            }
        }
        .chuang-management-list-title {
            width: @cons-description-width-size-1920;
            margin: 0 auto;
            margin-top: 2rem;
            margin-bottom: 2rem;
            @media @1920 {
                width: @cons-description-width-size-1920;
            }
            @media @1600 {
                width: @cons-description-width-size-1600;
            }
            @media @1400 {
                width: @cons-description-width-size-1400;
            }
            @media @1200 {
                width: @cons-description-width-size-1400 - 4;
            }
            @media @990 {
                width: @cons-description-width-size-990;
            }
            @media @768 {
                width: @cons-description-width-size-990;
            }
            @media @479 {
                width: @cons-description-width-size-990;
            }

            h5 {
                text-align: center;
                color: #e5e5e5;
                font-size: @cons-main-text-size-1600;
                margin-bottom: 1rem;
                @media @1920 {
                    font-size: @cons-main-text-size-1600;
                }
                @media @1600 {
                    font-size: @cons-main-text-size-1600;
                }
                @media @1400 {
                    font-size: @cons-main-text-size-1600;
                }
                @media @1200 {
                    font-size: @cons-main-text-size-1600;
                }
                @media @990 {
                    font-size: @cons-main-text-size-1600;
                }
                @media @768 {
                    font-size: @cons-main-text-size-1600;
                }
                @media @479 {
                    font-size: @cons-main-text-size-1600;
                }

            }

        }
        .chuang-management-list-description {
            p {
                color: #e5e5e5;
                font-size: @cons-description-text-size-1920;
                margin: 0 auto;
                margin-bottom: 5rem; 
                width: 25rem;
                @media @1920 {
                    font-size: @cons-description-text-size-1920;
                    width: 25rem;
                }
                @media @1600 {
                    font-size: @cons-description-text-size-1920;
                    width: 20rem;
                }
                @media @1400 {
                    font-size: @cons-description-text-size-1920;
                    width: 19rem;
                }
                @media @1200 {
                    font-size: @cons-description-text-size-1920;
                    width: 19rem;
                }
                @media @990 {
                    font-size: @cons-description-text-size-1920;
                    width: 30rem;
                }
                @media @768 {
                    font-size: @cons-description-text-size-1920;
                    width: 30rem;
                }
                @media @479 {
                    font-size: @cons-description-text-size-1920;
                    width: 19rem;
                }
                @media @360 {
                    font-size: @cons-description-text-size-1920; 
                    width: 19rem;
                }
                @media @320 {
                    font-size: @cons-description-text-size-1920;
                    width: 19rem;
                }
            }
        }
        .overwrite-row {
            margin-bottom: none!important;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/ChuangManagement.vue